enum SalesTeamPlansRoutes {
  List = '/sales-team-plans',
}

export default SalesTeamPlansRoutes
